export default {
  data: () => ({
    days: [
      {
        order: 0,
        pos: 1,
        day: 'Lunes',
      },
      {
        order: 1,
        pos: 2,
        day: 'Martes'
      },
      {
        order: 2,
        pos: 3,
        day: 'Miercoles'
      },
      {
        order: 3,
        pos: 4,
        day: 'Jueves',
      },
      {
        order: 4,
        pos: 5,
        day: 'Viernes',
      },
      {
        order: 5,
        pos: 6,
        day: 'Sabado',
      },
      {
        order: 6,
        pos: 0,
        day: 'Domingo',
      },
    ],
    selected_days: []
  })
}
